import React from 'react';
import { translate } from 'react-i18next';
import Card from '../card/Card';
import { FORMATTER_STYLE, getFormatter } from '../../utils/formatter';

class ProjectList extends React.Component {
  render() {
    const { t, i18n } = this.props;
    const statusMapper = {
      draft: 'status-pending',
      submitted: 'status-pending',
      rejected: 'status-failed',
      approved: 'status-passed',
    };

    const lang = i18n.language.split('-')[0];
    const ca = {
      en: 'gregory',
      th: 'buddhist',
    }[lang];

    const locale = `${i18n.language}-u-ca-${ca}`;
    return (
      <Card header={t('total projects')}>
        <div style={{ minHeight: 260 }}>
          <table>
            <thead>
              <tr>
                <th>{t('project name')}</th>
                <th>{t('date')}</th>
                <th>{t('type')}</th>
                <th>{`${t('area')} (${t('sq m')})`}</th>
                <th>{t('status')}</th>
              </tr>
            </thead>
            <tbody>
              {this.props.projects && this.props.projects.length > 0
                ? this.props.projects.map((project, index) => (
                    <tr key={index}>
                      <td>{project.name}</td>
                      <td>
                        {new Date(project.created_date).toLocaleDateString(locale, { year: 'numeric', month: '2-digit', day:'2-digit'})}
                      </td>
                      <td>{project[`building_type_name_${lang}`]}</td>
                      <td>{project.area == null ? '-' : getFormatter(FORMATTER_STYLE.floatFractionDigit2)(project.area)}</td>
                      <td>
                        <span
                          className={
                            'project-status ' + statusMapper[project.status.toLowerCase()]
                          }
                        >
                          {t(project.status.toLowerCase())}
                        </span>
                      </td>
                    </tr>
                  ))
                : <tr>
                  <td style={{ textAlign: 'center' }} colSpan={5}>{t('not found')}</td>
                </tr>}
            </tbody>
          </table>
        </div>
      </Card>
    );
  }
}

export default translate('translations')(ProjectList);



// WEBPACK FOOTER //
// ./src/components/projectlist/ProjectList.js